export { _pageTrackerLogger as pageTrackerLogger };
export { _pageTrackerPageView as pageTrackerPageView };
export { _hasInternalToken as hasInternalToken };
export { _retrieveUserGroups as retrieveUserGroups };

const INTERNAL_TOKEN = "3459923d_INTERNAL";

const _retrieveUserGroups = (groups) => {
  let userGroups = [];
  groups.forEach((group) => {
    if (group.toLowerCase().indexOf("user_") === 0 || group.includes("ADMIN")) {
      userGroups.push(group);
    }
  });
  return userGroups;
};

const _pageTrackerLogger = (msg) => {
  if (window.process.env.VUE_APP_DEPLOY_ENV.toLowerCase() === "test") {
    console.log(msg);
  }
};

const _pageTrackerPageView = (params) => {
  let _paq = (window._paq = window._paq || []);
  let url = params.url ? params.url : window.location.hash.substr(1);
  _pageTrackerLogger("Logged a page view for " + url);
  _paq.push(["setCustomUrl", "/" + url]);
  _paq.push(["setDocumentTitle", pageTrackerTitle(url)]);
  _paq.push(["trackPageView"]);
};

const pageTrackerTitle = (url) => {
  switch (url) {
    case "search":
      return "Live Search";
    case "signout":
      return "Sign Out";
    case "places":
      return "Places";
    case "alerts":
      return "Alerts";
    case "dashboard":
      return "Watch";
    case "collaboration":
      return "Content";
    case "hotspots":
      return "Hotspots";
    case "stability":
      return "Pulse";
    case "esri":
      return "Esri ArcGIS";
    case "events":
      return "Events";
    case "media":
      return "Media";
    case "latest":
      return "Latest";
    default:
      return "No title found.";
  }
};

const _hasInternalToken = (profile) => {
  const registrationToken =
    profile && profile.app_metadata
      ? profile.app_metadata.registrationToken
      : "";
  return registrationToken === INTERNAL_TOKEN;
};
